import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        baseURL: '',
        certification: false,
    },
    mutations: {
        setState(state,payload) {
            Vue.set(state,payload.key,payload.value)
        },
    },
    actions: {
        Init({commit}, payload){
            axios.get( this.state.baseURL + 'api/certification/show/' + payload.slug )
            .then( response => {
                if( response.data.success == "1" ){
                    commit("setState", {
                        key: "certification",
                        value: response.data.certification
                    });
                }

                if( response.data.success == "2" ){
                    console.log(payload.router);
                    payload.router.push({
                        path: "/"
                    });
                }
            })
            .catch(error => {
                console.log(error);
            });
        }
    },
    modules: {
    }
})
